import React, { useEffect } from "react";
import "./App.css";
import "./i18n"; // Initialize i18n
import { useTranslation } from "react-i18next";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import FreelancerDetailPage from "./pages/FreelancerDetailPage";
import CreateListingPage from "./pages/CreateListingPage";
import EditListingPage from "./pages/EditListingPage";
import MyListingsPage from "./pages/MyListingsPage";
import AdminPage from "./pages/AdminPage";
import SiteSettingsPage from "./pages/SiteSettingsPage";
import ContactPage from "./pages/ContactPage";
import DynamicPage from "./pages/DynamicPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import BlogManagementPage from "./pages/BlogManagementPage";
import SearchPage from "./pages/SearchPage";
import FavoritesPage from "./pages/FavoritesPage";
import SEOManagementPage from "./pages/SEOManagementPage";
import ProfilePage from "./pages/ProfilePage";
import NotFoundPage from "./pages/NotFoundPage";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import RouteProgress from "./components/RouteProgress";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <ErrorBoundary>
    <HelmetProvider>
      <AuthProvider>
        <div className="min-h-screen bg-zinc-800 flex flex-col">
          <BrowserRouter>
            <ScrollToTop />
            <RouteProgress />
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/freelancers" element={<SearchPage />} />
                <Route path="/escort/:id" element={<FreelancerDetailPage />} />
                <Route path="/freelancer/:id" element={<FreelancerDetailPage />} />
                <Route path="/create-listing" element={<CreateListingPage />} />
                <Route path="/edit-listing/:id" element={<EditListingPage />} />
                <Route path="/my-listings" element={<MyListingsPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/favorites" element={<FavoritesPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/settings" element={<SiteSettingsPage />} />
                <Route path="/admin/blog" element={<BlogManagementPage />} />
                <Route path="/admin/seo" element={<SEOManagementPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/page/:slug" element={<DynamicPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
            <BackToTop />
            <Toaster />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
